export enum StorageEnum {
  token = '@PE:token',
  student = '@PE:student',
  institution = '@PE:institution',
  admin = '@PE:admin',
}
